require('./plugin.js');